import client from './client';

export function listDataExchangeEntries(page = 1, limit = 24) {
  return client.get('/api/data-exchange', { params: { page, limit } });
}

export function uploadDataExchangeEntry({ file, title, remarks }, onUploadProgress) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('title', title || '');
  formData.append('remarks', remarks || '');
  return client.post('/api/data-exchange', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress,
  });
}

export function updateDataExchangeEntry(id, payload) {
  return client.put(`/api/data-exchange/${id}`, payload);
}

export function deleteDataExchangeEntry(id) {
  return client.delete(`/api/data-exchange/${id}`);
}

export function bulkDeleteDataExchangeEntries(payload) {
  return client.post('/api/data-exchange/bulk-delete', payload);
}

export function getDataExchangeBlob(id, download = false) {
  return client.get(`/api/data-exchange/${id}/${download ? 'download' : 'content'}`, {
    responseType: 'blob',
  });
}

export function listDataExchangeAnnotations(assetId) {
  return client.get(`/api/data-exchange/${assetId}/annotations`);
}

export function createDataExchangeAnnotation(assetId, payload) {
  return client.post(`/api/data-exchange/${assetId}/annotations`, payload);
}

export function updateDataExchangeAnnotation(assetId, annotationId, payload) {
  return client.put(`/api/data-exchange/${assetId}/annotations/${annotationId}`, payload);
}

export function deleteDataExchangeAnnotation(assetId, annotationId) {
  return client.delete(`/api/data-exchange/${assetId}/annotations/${annotationId}`);
}

export function listDataExchangeGuestLinks() {
  return client.get('/api/data-exchange/guest-links');
}

export function createDataExchangeGuestLink(label) {
  return client.post('/api/data-exchange/guest-links', { label });
}

export function revokeDataExchangeGuestLink(linkId) {
  return client.delete(`/api/data-exchange/guest-links/${linkId}`);
}